import { useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import useAppStore from '../../store/app.store';
import useTema from '../../hooks/useTema';
import { IcBell, IcCheck } from './Icons';
import api from '../../services/api';

const TIPO_COR = {
  producao_atribuida: '#8b5cf6',
  chamado_aberto:     '#0ea5e9',
  chamado_atualizado: '#f59e0b',
  reuniao_agendada:   '#10b981',
  pauta:              '#8b5cf6',
  default:            '#64748b',
};

function tempoRelativo(iso) {
  const diff = Date.now() - new Date(iso).getTime();
  const min  = Math.floor(diff / 60000);
  if (min < 1)  return 'agora';
  if (min < 60) return `${min}m atrás`;
  const h = Math.floor(min / 60);
  if (h < 24)  return `${h}h atrás`;
  return `${Math.floor(h / 24)}d atrás`;
}

export default function NotificacoesPanel({ onClose }) {
  const t         = useTema();
  const navigate  = useNavigate();
  const panelRef  = useRef(null);
  const usuario   = useAppStore(s => s.usuario);
  const notifs    = useAppStore(s => s.notificacoes);
  const marcarLida      = useAppStore(s => s.marcarLida);
  const marcarTodasLidas = useAppStore(s => s.marcarTodasLidas);

  const minhas = notifs
    .filter(n => n.destinatario_id === usuario?.id)
    .slice(0, 20);

  const naoLidas = minhas.filter(n => !n.lida).length;

  useEffect(() => {
    const handler = (e) => {
      if (panelRef.current && !panelRef.current.contains(e.target)) onClose();
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, [onClose]);

  const handleClick = (n) => {
    marcarLida(n.id);
    api.patch(`/notificacoes/${n.id}`).catch(() => {});
    if (n.tipo === 'pauta' || n.tipo === 'projetos') navigate(n.tipo === 'pauta' ? '/pauta' : '/projetos');
    else if (n.referencia_tipo === 'producao') navigate('/midias');
    else if (n.referencia_tipo === 'chamado') navigate('/chamados');
    else if (n.referencia_tipo === 'reuniao') navigate('/reunioes');
    onClose();
  };

  return (
    <div ref={panelRef}
      className="absolute right-0 top-full mt-2 w-80 rounded-2xl overflow-hidden z-50"
      style={{ background: t.bgCard, border: `1px solid ${t.border}`, boxShadow: '0 12px 40px rgba(0,0,0,0.3)' }}>

      {/* Cabeçalho */}
      <div className="flex items-center justify-between px-4 py-3" style={{ borderBottom: `1px solid ${t.border}` }}>
        <div className="flex items-center gap-2">
          <IcBell size={14} style={{ color: t.textMuted }} />
          <span className="text-sm font-semibold" style={{ color: t.text }}>Notificações</span>
          {naoLidas > 0 && (
            <span className="text-[10px] font-bold px-1.5 py-0.5 rounded-full text-white"
              style={{ background: '#8b5cf6' }}>{naoLidas}</span>
          )}
        </div>
        {naoLidas > 0 && (
          <button onClick={() => { marcarTodasLidas(usuario?.id); api.patch('/notificacoes/lidas').catch(() => {}); }}
            className="text-xs flex items-center gap-1"
            style={{ color: '#8b5cf6' }}>
            <IcCheck size={11} /> Marcar todas
          </button>
        )}
      </div>

      {/* Lista */}
      <div className="max-h-96 overflow-y-auto">
        {minhas.length === 0 ? (
          <div className="py-10 text-center">
            <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 8, color: t.textMuted, opacity: 0.4 }}><IcBell size={28} /></div>
            <p className="text-sm" style={{ color: t.textMuted }}>Sem notificações</p>
          </div>
        ) : minhas.map(n => (
          <button key={n.id} onClick={() => handleClick(n)}
            className="w-full flex items-start gap-3 px-4 py-3 text-left transition-colors"
            style={{
              borderBottom: `1px solid ${t.borderLight}`,
              background: n.lida ? 'transparent' : (t.bgCardAlt),
            }}
            onMouseEnter={e => e.currentTarget.style.background = t.bgCardHover}
            onMouseLeave={e => e.currentTarget.style.background = n.lida ? 'transparent' : t.bgCardAlt}>
            <span className="w-2 h-2 rounded-full mt-1.5 flex-shrink-0"
              style={{ background: n.lida ? 'transparent' : (TIPO_COR[n.tipo] || TIPO_COR.default) }} />
            <div className="flex-1 min-w-0">
              <p className="text-xs font-semibold truncate" style={{ color: t.text }}>{n.titulo}</p>
              <p className="text-xs mt-0.5 leading-relaxed" style={{ color: t.textSecond }}>{n.mensagem}</p>
              <p className="text-[10px] mt-1" style={{ color: t.textMuted }}>{tempoRelativo(n.criado_em)}</p>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
}
